"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectHideSenderImageOption_1 = require("../actions/selectHideSenderImageOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
// import ReadReceiptResponse from 'owa-service/lib/contract/ReadReceiptResponse';
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
var SenderImageFull = /** @class */ (function (_super) {
    tslib_1.__extends(SenderImageFull, _super);
    function SenderImageFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHideSenderImageChange = function (ev, option) {
            selectHideSenderImageOption_1.default(option.key === 'true');
        };
        return _this;
    }
    SenderImageFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var showSenderImageInListView = owa_options_core_1.getFallbackValueIfNull(optionStore.showSenderImageInListView, !listViewBitFlagsUtil_1.getIsBitSet(8 /* HideSenderImage */));
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + showSenderImageInListView, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_messageList_showSenderImage,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_messageList_hideSenderImage,
                },
            ], onChange: this.onHideSenderImageChange, label: owa_options_strings_1.default.options_messageList_senderImageLabel }));
    };
    SenderImageFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
        })
    ], SenderImageFull);
    return SenderImageFull;
}(React.Component));
exports.default = SenderImageFull;
//# sourceMappingURL=SenderImageFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/components/SenderImageFull.js
// module id = 5100
// module chunks = 2